import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';

export const useNeedsAccountVerification = (): boolean => {
  const userInfo = useAppSelector(userSlice.selectLoggedInUserInfo);
  return userInfo && !userInfo.isMemberAssociated;
};
